/**
 * 长按
 */
import './style.scss';

export default function taphold(app, done) {
  // init

  const appConfig = app.appConfig;
  const config = appConfig.get('appConfig');
  // const qs = appConfig.get('qs');

  // 设置placeholder
  app.view.footer.setPlaceholder(config.inputTip);
  // 设置导航栏title
  if (config.headerTitle) {
    // if (app.bridge.detect('setTitle')) {
    //   app.bridge.call('setTitle', {
    //     title: config.headerTitle,
    //   });
    // } else {
    //   document.title = config.headerTitle;
    // }
  }

  // 是否隐藏语音
  if (config.hideVoice) {
    app.view.footer.input.hideVoice();
  }

  // skin
  if (config.theme) {
    const theme = config.theme;
    app.util.setCss(theme.name, theme.url);
    // iconfont地址不一定有
    if (theme.icon) {
      app.util.setIconfont(theme.icon);
    }
  }

  // 机器人头像
  if (config.robotAvatar) {
    app.view.header.setCustomedAvatar(config.robotAvatar);
  }
  done();
}



// WEBPACK FOOTER //
// ./src/app/module/customUI/index.js